import { render, staticRenderFns } from "./common-broadcast.vue?vue&type=template&id=0ab4a2fc"
import script from "./common-broadcast.vue?vue&type=script&lang=js"
export * from "./common-broadcast.vue?vue&type=script&lang=js"
import style0 from "./common-broadcast.vue?vue&type=style&index=0&id=0ab4a2fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports